module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "savings",
    class: {
      print: _vm.printing
    }
  }, [_c('h1', [_vm._v("Årlig besparing")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_vm._v("\n      " + _vm._s(_vm.priceDifference) + " "), (_vm.printing) ? _c('br') : _vm._e(), _c('span', [_vm._v("KR")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "slider-row"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("Körsträcka per år"), _c('span', [_vm._v(_vm._s(_vm._f("normalize")(_vm.mileage)) + " mil")])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "slider-row"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("Drivmedelspris"), _c('span', [_vm._v(_vm._s(_vm._f("toDecimal")(_vm._f("normalize")(_vm.highestValueOfCompanies))) + " kr/liter")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "slider-row"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("Antal fordon"), _c('span', [_vm._v(_vm._s(_vm.cars) + " st")])]), _vm._v(" "), _vm._m(3)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "wrap explanation"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "placeholder",
    class: {
      expanded: _vm.expanded
    },
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_vm._v("\n          Så här har vi räknat "), _c('div', {
    staticClass: "arrow"
  })]), _vm._v(" "), _c('transition', {
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [(_vm.expanded || _vm.printing) ? _c('div', {
    staticClass: "text"
  }, [_vm._v("\n            Spargeneratorn är baserad på ett fordon som har en medelförbrukning på 0,7 liter/mil (diesel). Uträkningen är baserad på mellanskillnaden mellan den dyraste aktörens pris och Tankas pris. Angivna drivmedelspriser på Drivmedelsguiden är inhämtade från respektive aktörs hemsida.")]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "button-row"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.$emit('sendToPrinting')
      }
    }
  }, [_vm._v("Spara PDF")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "bottom"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "slider",
    attrs: {
      "id": "mileage"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "slider",
    attrs: {
      "id": "price"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "slider",
    attrs: {
      "id": "cars"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c07b7d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/views/savings.vue
// module id = 287
// module chunks = 1